// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mda8","colBig":"styles_colBig__1Qokg","colSmall":"styles_colSmall__N41W4","shopifyNameWrapper":"styles_shopifyNameWrapper__3ANDo"};